<template lang="pug">
  .time-combobox
    app-select(v-bind="$props" @input="setTime" searchable)
      template(v-slot:field="{toggle, updateShowing}")
        .time-combobox__field(:class="{'time-combobox--error': hasErrors}")
          v-icon(size="15" :color="value ? '#272c32' : 'inherit'") mdi-clock-outline
          validation-provider(ref="provider" rules="time" v-slot="{ errors }")
            input(
              :value="time"
              @input="changeTime($event.target.value, updateShowing)"
              :disabled="disabled"
              :placeholder="placeholder"
              v-on:keyup.enter="inputTime($event.target.value)"
              @click="toggle"
            )

    img(src="@/assets/img/ui/close.svg" @click="resetTime" :class="['close-icon', {'active': value}]")
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import showingMixin from '@/mixins/showing.mixin';
import { ERRORS_MESSAGES } from '@/util/const';

extend('time', {
  validate(value) {
    const regexRule = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/gm;
    return regexRule.test(value);
  }, message: ERRORS_MESSAGES.ERROR_FIELD
});

export default {
  name: 'TimeCombobox',

  mixins: [showingMixin],

  props: {
    value: {
      required: false
    },
    text: Boolean,
    placeholder: String,
    label: String,
    options: {
      type: Array,
      required: true
    },
    slugKey: {
      type: String,
    },
    slugValue: {
      type: String
    },
    hideArrow: Boolean,
    error: Boolean,
    errorMessages: String,
    requiredField: Boolean,
    returnObject: Boolean,
    searchable: Boolean,
    placement: String,
    disabled: Boolean,
    boundariesElement: {
      type: [ String, Element ],
      default: '.time-combobox__field'
    }
  },

  data: () => ({
    time: null
  }),

  computed: {
    hasErrors() {
      return !!(this.time && this.$refs.provider?.errors[0]);
    }
  },

  methods: {
    setTime(value) {
      this.time = value
      this.$emit('input', value)
    },

    inputTime(value) {
      if (!this.hasErrors) this.$emit('input', value)
    },

    changeTime(value, updateShowing) {
      this.time = value
      updateShowing(false)
    },

    resetTime() {
      this.time = null
      this.$emit('input', null)
    }
  },

  mounted() {
    if (this.value) this.time = this.value
  },

  components: {
    ValidationProvider,
    appSelect: () => import('@/components/global/actions/BaseSelect.vue')
  }
}
</script>

<style lang="scss">
.time-combobox {
  position: relative;
  margin-bottom: 6px;
  margin-right: 15px;

  @include media("<=tablet") {
    margin: 0 5px 5px 0;
  }

  &__field {
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    min-width: 140px;
    max-width: 140px;
    border-radius: 4px;
    background-color: #f5f7f9;
    cursor: pointer;
    padding: 0 10px;

    input {
      display: flex;
      width: 100%;
      outline: none;
      color: $title-second;
      font-weight: 500;
      font-size: 12px;
      padding: 0 5px;

      &::placeholder {
        color: #758289;
        font-size: 12px;
      }
    }
  }

  &--error {
    border: 1px solid $error-color;
  }

  .close-icon {
    display: none;
    width: 26px;
    height: 26px;
    position: absolute;
    top: -10px;
    left: auto;
    right: -10px;
    cursor: pointer;
    transition: opacity 0.3s ease-in-out;

    @include media("<=tablet") {
      right: -5px;
    }

    &.active {
      display: block;
      transition: opacity 0.3s ease-in-out;
    }
  }
}
</style>
